// Pre-processing of the HTML a standalone single-page export shows
// (HTMLRenderer): a comparison sheet cut out of the bundle a full export
// saved, by pdf-generator-lambdas' singlePageExport_adapter.

// Removes the href of unnecessary anchors (for single page exports)
const removeUnnecessaryAnchorHrefs = (html) => {
  const matching_links = html.match(/<[a-zA-Z-]+[^>]+removeHrefForSPE[^>]*>/g);
  if (!matching_links) return html;

  // Sanitize found anchors
  matching_links.forEach((anchor_str) => {
    const replacement = anchor_str.replace(/href=".*"/, "");
    html = html.replace(anchor_str, replacement);
  });

  return html;
};

// Restores the href of PDF links (pdf-link class). The full export's
// getPdfPromotions moved each PDF link's href to data-pdf-href so the link
// could become a jump to the appended copy. Here the link must work again:
// on the web it opens the PDF, and the export from this page collects it
// the same way the full export did.
const restorePdfLinkHrefs = (html) => {
  const matching_links = html.match(/<a\s[^>]*data-pdf-href="[^"]*"[^>]*>/g);
  if (!matching_links) return html;

  matching_links.forEach((anchor_str) => {
    if (/\shref="/.test(anchor_str)) return;
    const href = anchor_str.match(/data-pdf-href="([^"]*)"/)[1];
    const replacement = anchor_str.replace(
      /\sdata-pdf-href="/,
      ` href="${href}" data-pdf-href="`
    );
    html = html.replace(anchor_str, replacement);
  });

  return html;
};

// Pre-process HTML
// - Remove promo links that link another page in the full comparison
// - Give PDF links their href back
export const processHTML = (html) => {
  html = removeUnnecessaryAnchorHrefs(html);
  html = restorePdfLinkHrefs(html);

  return html;
};
